import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/internal/Subscription';

import { RunningMessage } from 'src/app/models';
import { AuthService, TokenService, DialogService, CreditService } from 'src/app/services';

import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'cm-log-info',
  templateUrl: './log-info.component.html',
  styleUrls: ['./log-info.component.css']
})
export class LogInfoComponent implements OnInit, OnDestroy {
  @Input() runningMessages: RunningMessage[] = [];

  protected displayReport: boolean = false;
  protected creditBalance: number = 0.00;
  protected showAnimation : boolean  = false;

  constructor(
    private token: TokenService,
    private translate: TranslateService,
    protected auth: AuthService,
    private dialogService: DialogService,
    private creditService: CreditService
  ) {
    this.runningMessages = [];
  }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.refreshBalance();
    }
    this.creditService.creditBalance$.subscribe(balance => {
      this.creditBalance = balance;
    });
  }

  ngOnDestroy(): void {
  }

  logout() {
    this.auth.logout().subscribe(
      (success) => {
        if (success) {
          console.log('Successfully logged out');
        } else {
          console.error('Logout failed');
        }
      },
      (error) => {
        console.error('Logout error', error);
      }
    );
  }

  showChangePasswordDialog(): void {
    this.dialogService.openChangePasswordDialog();
  }

  showReportDialog(): void {
    this.dialogService.openReportDialog();
  }

  protected refreshBalance() {
    // this.creditBalance = 168.88;
    this.creditService.refreshBalance();
  }

  triggerAnimation(isTestGame: boolean): void {
    if(isTestGame){
      this.showAnimation = true;
      this.auth.setTestGame(true);
    }
    else{
      this.showAnimation = false;
      this.auth.setTestGame(false);
    }
  }
}
